export default "__VITE_ASSET__1fa5e538__"